// Environnement BO (back-office app.akces.fr) — build distinct du FO public.
//
// pro=true active toutes les routes /manage/* (cf. fo-routing.module.ts +
// bo.routes.ts qui swap leur structure selon ce flag) et le design pro.
//
// Utilisé via la configuration Angular `production-bo` (cf. angular.json),
// lancée par `npm run build:bo`.
export const environment = {
  production: true,
  pro: true,
  iframe: false,
  apiBaseUrl: "https://api.akces.fr/api",
  baseUrl: "https://api.akces.fr",
  fbAppId: "259796547837759",
  // Google OAuth — pas affiché en BO (modePro masque le bouton sur le
  // login-form) mais le Client ID est mis pour cohérence si jamais on
  // active le Google Sign-In côté BO plus tard.
  googleClientId: "625657961352-srbir08hsim3ckg5g3fl8povq0sju91c.apps.googleusercontent.com",
  cawlEnabled: false,
};
